<template>
   <MenuNavigator v-if="$route.meta.hasNav" :homePage="homePage" :project="project" :appId="appId" :secret="secret" :apiUrl="apiUrl"  :route="route" :router="router" :coreapi="coreapi" :avatar="avatar" >
  </MenuNavigator>

  <router-view v-else v-slot="{ Component, route }">
    <keep-alive v-if="route.meta.keepAlive">
      <component :is="Component" />
    </keep-alive>
    <component v-else :is="Component" />
  </router-view>
</template>

<script setup>
import {ref} from "vue";
import { useRoute, useRouter } from "vue-router";
import getConfig from "@/utils/getConfig.js";
import mravatar from '@/assets/images/avatar.jpg';

const { project, appId, secret, apiUrl,coreapi } = getConfig();
const router = useRouter();
const route = useRoute();
const avatar=ref(mravatar);

window.addEventListener('popstate', function(event) {
  // 处理返回事件
  if(event.state.current==='/login'){
     location.reload();
     localStorage.clear();
  }
});


</script>

<style>


</style>
